const deviceType = IsPC()?'pc':'mobile'
const host = process.env.NODE_ENV == 'development' ? 'http://172.30.1.101:5000/' : 'https://api-m3guo.17m3.com/';
const webUrl = process.env.NODE_ENV == 'development' ? 'http://192.168.217.171:2887/' : 'https://www.m3guo.com/activity/202209/ck35ee5/';
const domain = deviceType == 'pc' ? webUrl + 'index.html' : webUrl + 'index.html';

const activityTime = '9月1日-9月28日';

const getQueryVariable = function (variable) {
    var query = window.location.search.substring(1) || window.location.hash.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
        return pair[1];
        }
    }
    return '';
}

const tipsImg = ['D774', 'K814', 'KB55', 'KB56', 'KQ48', 'KR26', 'KR30', 'KW23', 'LC09', 'LC12', 'LJ06', 'LP51', 'LP59', 'Y550', 'Y552', 'Y819', 'Y867', 'KE89'];

let search_code = getQueryVariable('code') ? ('?code=' + getQueryVariable('code')) : '';
let add = getQueryVariable('code') ? '&' : '?';
let search_key = getQueryVariable('key') ? (add + 'key=' + getQueryVariable('key')) : '';

const wx_share_text = {
  title: '天命狐王孙策登场', // 分享标题
  desc: '鸡王争霸第5期', // 分享描述
  imgUrl: 'https://web-resource.17m3.com/m3guo/202209/ck/sns.jpg', // 分享图标   
}

const issn = '220802';

const ajax_url_map = {
  login : host + 'api/login/authorize?callbackurl=' + encodeURIComponent(domain) + '&issn=' + issn,
  logout : '',
  free : host + 'api/Login/KouDai',
  logininfo : host + 'api/user/getLoginInfo',
  userinfo : host + 'api/chicken/getUserInfo',
  queryplayer : host + 'api/user/GetNickName',
  bind : host + 'api/user/bind',
  task : host + 'api/userTask/taskList',//任务列表
  apply: host + 'api/chicken/commit',//一键领取 1:一键领取 2:枪王福利宝箱 3:枪王升级宝箱 4:回馈奖励，大吉大利鸡王宝藏
  mplat : host + 'api/login/mplat',//梦平台免登录
  buy : host + 'api/chicken/buy',//购买 1:经验,2:599鸡王,8:加码礼包1,16:加码礼包2,32:鸡王系列换装包,64:枪王之王特惠包
  skin : host + 'api/chicken/querySkin',//皮肤查询
  tips : 'https://tool.m3guo.com/api/web/m3goods/eq-item/',//tip获取
  rank : 'https://ssl-dataapi.17m3.com/index.php/interfaceManage/interfaceForCommonUse?uniq_id=qgeyz3',//排行榜
}

const EXP = [500, 1000, 1500, 2000];

const level = [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000];

const end = ['9月7日','9月14日','9月21日','9月28日'];

const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const param =  function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
    '=' + encodeURIComponent(json[key])
  })).join('&')
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
}

const areaList = [{
  "id": 1,
  "name": "火烧赤壁"
}, {
  "id": 2,
  "name": "草船借箭"
}, {
  "id": 6,
  "name": "荆州之战"
}, {
  "id": 7,
  "name": "青梅煮酒"
}, {
  "id": 11,
  "name": "九伐中原"
}, {
  "id": 16,
  "name": "怀旧服"
}, {
  "id": 8,
  "name": "官渡之战"
}, {
  "id": 9,
  "name": "桃园结义"
}, {
  "id": 19,
  "name": "火凤燎原"
}, {
  "id": 20,
  "name": "卧龙出渊"
},
{
  "id": 21,
  "name": "长生殿(Steam)"
}, 
{
  "id": 17,
  "name": "铜雀台(wegame1)"
}, {
  "id": 18,
  "name": "凤仪亭(wegame2)"
}, {
  "id": 100,
  "name": "TEST_1"
}, {
  "id": 110,
  "name": "TEST_2"
}
]

const queryArea = function (num){
  var area = '暂无大区信息';

  if (num == 1) {
      area = '火烧赤壁';
  } else if (num == 2) {
      area = '草船借箭';
  } else if (num == 6) {
      area = '荆州之战';
  } else if (num == 7) {
      area = '青梅煮酒';
  } else if (num == 8) {
      area = '官渡之战';
  } else if (num == 9) {
      area = '桃园结义';
  } else if (num == 11) {
      area = '九伐中原';
  } else if (num == 12) {
      area = '逐鹿中原';
  } else if (num == 13) {
      area = '三分天下';
  } else if (num == 16) {
      area = '怀旧服';
  }else if (num == 17) {
      area = '铜雀台';
  } else if (num == 18) {
      area = '凤仪亭';
  }else if (num == 19) {
      area = '火凤燎原';
  }else if (num == 20) {
      area = '卧龙出渊';
  }else if (num == 21) {
      area = '长生殿';
  }else if (num == 100 || num == 101) {
      area = '测试大区';
  }

  return area;
}


export default {
    ajax_url_map,
    getQueryVariable,
    domain,
    param,
    deviceType,
    areaList,
    issn,
    activityTime,
    tipsImg,
    wx_share_text,
    EXP,
    level,
    end,
    queryArea,
}


// WEBPACK FOOTER //
// ./src/assets/js/global.js